import { call, takeLatest } from "redux-saga/effects";
import {
  bulkUploadPaymentsApi,
  paymentHistoryApi,
} from "../apis/coco-bulk-payment-api";
import {
  COCO_BULK_PAYMENT_UPLOAD,
  COCO_PAYMENT_HISTORY_GET,
} from "../types";

export function* cocoBulkPaymentUploadWorker(action) {
  try {
    const res = yield call(bulkUploadPaymentsApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* cocoPaymentHistoryWorker(action) {
  try {
    const res = yield call(paymentHistoryApi, action.data);
    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* cocoBulkPaymentUploadWatcher() {
  yield takeLatest(COCO_BULK_PAYMENT_UPLOAD, cocoBulkPaymentUploadWorker);
}

export function* cocoPaymentHistoryWatcher() {
  yield takeLatest(COCO_PAYMENT_HISTORY_GET, cocoPaymentHistoryWorker);
}
